export const usePropsMapper = (hooks) => {
  const { auth, video, historySync, translation, transcript, qa, analysis, resume, 
          globalCopy, swipe, headerAnalyze, pageGuard, 
          historyId, navigate, theme, activeTab, setActiveTab, t, i18n, isMobile, 
          transcriptLoading, headerHeight, sidebarWidth, isPageLoading, isActiveStreaming } = hooks;

  // PageHeader Props 매핑
  const pageHeaderProps = {
    // SEO props
    streamingSummary: video.streamingSummary,
    selectedHistory: historySync.selectedHistory,
    
    // Header props
    inputUrl: video.inputUrl,
    setInputUrl: video.setInputUrl,
    inputTitle: video.inputTitle,
    loading: video.loading,
    error: video.error,
    isLoggedIn: auth.isLoggedIn,
    userEmail: auth.userEmail,
    user: auth.user,
    handleLogout: auth.handleLogout,
    handleAnalyze: headerAnalyze.handleHeaderAnalyze,
    drawerOpen: video.drawerOpen,
    setDrawerOpen: video.setDrawerOpen,
    setLoginDialogOpen: auth.setLoginDialogOpen,
    fetchYoutubeTitle: video.fetchYoutubeTitle
  };

  // HistoryDrawer Props 매핑
  const historyDrawerProps = {
    drawerOpen: video.drawerOpen,
    setDrawerOpen: video.setDrawerOpen,
    history: video.history,
    setHistory: video.setHistory,
    selectedHistoryId: historySync.selectedHistoryId,
    setSelectedHistoryId: historySync.setSelectedHistoryId,
    setAnalyzedVideoId: video.setAnalyzedVideoId,
    setAnalyzedTitle: video.setAnalyzedTitle,
    setAnalyzedUrl: video.setAnalyzedUrl,
    editingHistoryId: video.editingHistoryId,
    setEditingHistoryId: video.setEditingHistoryId,
    editingTitle: video.editingTitle,
    setEditingTitle: video.setEditingTitle,
    handleEditHistory: video.handleEditHistory,
    handleDeleteClick: video.handleDeleteClick,
    userId: auth.userId,
    HEADER_HEIGHT: headerHeight,
    SIDEBAR_WIDTH: sidebarWidth
  };

  // MainLayoutContainer Props 매핑
  const mainLayoutProps = {
    // 스와이프 관련
    activeColumn: swipe.activeColumn,
    setActiveColumn: swipe.setActiveColumn,
    swipeHandlers: swipe.swipeHandlers,
    
    // 비디오 관련
    isStreaming: video.isStreaming,
    analyzedVideoId: video.analyzedVideoId,
    analyzedTitle: video.analyzedTitle,
    analyzedUrl: video.analyzedUrl,
    selectedHistory: historySync.selectedHistory,
    onPlayerStateChange: transcript.onPlayerStateChange,
    playerRef: video.playerRef,
    
    // 자막 관련
    scriptArr: transcript.scriptArr,
    activeIdx: transcript.activeIdx,
    autoScroll: transcript.autoScroll,
    setAutoScroll: transcript.setAutoScroll,
    scriptRefs: transcript.scriptRefs,
    transcriptLoading,
    showTranslated: translation.showTranslated,
    handleToggleTranslation: translation.handleToggleTranslation,
    currentTranscript: translation.currentTranscript,
    
    // 요약 관련
    loading: video.loading,
    streamingSummary: video.streamingSummary,
    streamingChapters: video.streamingChapters,
    activeTab,
    setActiveTab,
    streamingChunkSummaries: video.streamingChunkSummaries,
    
    // QA 관련
    qaInput: qa.qaInput,
    setQaInput: qa.setQaInput,
    qaLoading: qa.qaLoading,
    handleQaSend: qa.handleQaSend,
    qaHistory: qa.qaHistory,
    recommendedQuestions: qa.recommendedQuestions,
    handleRecommendedQuestionClick: qa.handleRecommendedQuestionClick,
    qaScrollRef: qa.qaScrollRef
  };

  // ModalContainer Props 매핑
  const modalProps = {
    // LoginDialog props
    loginDialogOpen: auth.loginDialogOpen,
    setLoginDialogOpen: auth.setLoginDialogOpen,
    isSignup: auth.isSignup,
    setIsSignup: auth.setIsSignup,
    email: auth.email,
    setEmail: auth.setEmail,
    password: auth.password,
    setPassword: auth.setPassword,
    handleEmailAuth: auth.handleEmailAuth,
    handleGoogleAuth: auth.handleGoogleAuth,
    handleKakaoAuth: auth.handleKakaoAuth,
    
    // DeleteDialog props
    deleteDialogOpen: video.deleteDialogOpen,
    setDeleteDialogOpen: video.setDeleteDialogOpen,
    handleDeleteConfirm: video.handleDeleteConfirm,
    history: video.history,
    deleteTargetId: video.deleteTargetId,
    
    // ErrorModal props
    errorModalOpen: video.errorModalOpen,
    closeErrorModal: video.closeErrorModal,
    errorType: video.errorType,
    handleRetry: video.handleRetry,
    errorMessage: video.errorMessage,
    
    // ProgressModal props
    progressModal: video.progressModal,
    handleAnalysisCancel: video.handleDirectCancel,
    visualProgress: video.visualProgress,
    
    // GlobalCopyProgressModal props
    globalCopyModal: globalCopy.globalCopyModal,
    closeGlobalCopyModal: globalCopy.closeGlobalCopyModal,
  };

  return {
    pageHeaderProps,
    historyDrawerProps,
    mainLayoutProps,
    modalProps
  };
}; 